import Button from 'components/Button';
import Notification from 'components/Notification';
import Panel from 'components/Panel';
import SignOffDocumentModal from 'pages/Portal/ClientInboxItem/SignOffDocumentModal';
import {
    AcceptOrderState,
    ClientInboxItemBackend,
} from 'pages/Portal/ClientInboxItem/types';
import {FC, useState} from 'react';
import {useBackend} from 'state/backend';
import {c} from 'ttag';

const AcceptOrderPanel: FC = () => {
    const {
        data: {
            canAcceptOrder,
            document,
            loggedInPartner,
            orderAccepted,
            portalMid,
            sendingPartner,
        },
    } = useBackend<ClientInboxItemBackend>();

    const type =
        document.documentType === 'acceptance' ? 'confirmation' : 'order';

    const [isOpen, setIsOpen] = useState(false);
    const [state, setState] = useState<AcceptOrderState>(() => {
        if (loggedInPartner?.mid === sendingPartner.mid) {
            return 'ownDocument';
        }

        if (document.dateCancelled) {
            return 'cancelled';
        }

        if (orderAccepted) {
            return 'accepted';
        }

        if (canAcceptOrder) {
            return 'signable';
        }

        return undefined;
    });

    if (!canAcceptOrder) {
        return null;
    }

    let content;

    if (state === 'ownDocument') {
        content = (
            <Notification type="alert">
                {
                    {
                        confirmation: c('signoff-confirmation')
                            .t`You cannot sign off on your own company's documents.`,
                        order: c('signoff-order')
                            .t`You cannot sign off on your own company's documents.`,
                    }[type]
                }
            </Notification>
        );
    } else if (state === 'cancelled') {
        content = (
            <Notification type="alert">
                {c('signoff').t`This document was cancelled by the sender.`}
            </Notification>
        );
    } else if (state === 'accepted') {
        content = (
            <Notification type="success">
                {
                    {
                        confirmation: c('signoff-confirmation')
                            .t`This document was accepted, and the sender has been notified. Thank you.`,
                        order: c('signoff-order')
                            .t`This document was accepted, and the sender has been notified. Thank you.`,
                    }[type]
                }
            </Notification>
        );
    } else if (state === 'signable') {
        content = (
            <Button
                className="w-full"
                kind="secondary"
                onClick={() => {
                    setIsOpen(true);
                }}
                size="base"
            >
                {
                    {
                        confirmation: c('signoff-confirmation').t`Sign Off`,
                        order: c('signoff-order').t`Sign Off`,
                    }[type]
                }
                {/* {t(`signOffDocumentModal.${type}.signOff`)} */}
            </Button>
        );
    }

    return (
        <>
            <Panel
                title={
                    {
                        confirmation: c('signoff-confirmation').t`Sign Off`,
                        order: c('signoff-order').t`Sign Off`,
                    }[type]
                }
            >
                {document.hasTotals && (
                    <div className="mb-4 flex justify-between font-medium">
                        <p>{c('signoff').t`Document Total`}</p>
                        <p>{document.total}</p>
                    </div>
                )}
                {content}
            </Panel>
            <SignOffDocumentModal
                document={document}
                isOpen={isOpen}
                onClose={() => {
                    setIsOpen(false);
                }}
                portalMid={portalMid}
                setState={setState}
            />
        </>
    );
};

export default AcceptOrderPanel;
